import { onValue, push, ref, remove, set } from "firebase/database";
import { useEffect, useState } from "react";
import { database } from "../firebase";

const SuccessStoryManager = () => {
  const [imageFile, setImageFile] = useState(null);
  const [name, setName] = useState("");
  const [place, setPlace] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const convertToBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });

  useEffect(() => {
    const imagesRef = ref(database, "carouselImages");
    const unsub = onValue(imagesRef, (snapshot) => {
      const data = snapshot.val();
      setImages(data ? Object.values(data) : []);
    });
    return () => unsub();
  }, []);

  const handleUpload = async () => {
    if (!imageFile || !name || !place) {
      setMsg("Please fill all fields and select an image.");
      return;
    }
    setLoading(true);
    const base64Url = await convertToBase64(imageFile);
    const newRef = push(ref(database, "carouselImages"));
    await set(newRef, { id: newRef.key, url: base64Url, name, place });
    setImageFile(null);
    setName("");
    setPlace("");
    setMsg("Added successfully!");
    setLoading(false);
    setTimeout(() => setMsg(""), 2000);
  };

  const handleDelete = (id) => remove(ref(database, "carouselImages/" + id));

  return (
    <div className="container mt-3">
      <h5 className="fw-bold pb-2 mb-3" style={{ borderBottom: '2px solid #90b732', color: '#90b732' }}>Our Success Story — Manage Images</h5>

      {msg && <div className="alert alert-success py-2">{msg}</div>}

      <div className="card p-3 mb-4 shadow-sm">
        <div className="row g-2">
          <div className="col-md-4">
            <label className="form-label fw-semibold">Student Image</label>
            <input type="file" accept="image/*" className="form-control"
              onChange={(e) => setImageFile(e.target.files[0])} />
          </div>
          <div className="col-md-3">
            <label className="form-label fw-semibold">Student Name</label>
            <input type="text" className="form-control" placeholder="e.g. Vinay Rathore"
              value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label className="form-label fw-semibold">City / Place</label>
            <input type="text" className="form-control" placeholder="e.g. Damoh"
              value={place} onChange={(e) => setPlace(e.target.value)} />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button className="btn w-100" style={{ background: '#90b732', color: '#fff' }} onClick={handleUpload} disabled={loading}>
              {loading ? "Uploading..." : "Add"}
            </button>
          </div>
        </div>
      </div>

      <table className="table table-bordered table-hover text-center align-middle">
        <thead style={{ background: '#90b732', color: '#fff' }}>
          <tr><th>#</th><th>Image</th><th>Name</th><th>Place</th><th>Action</th></tr>
        </thead>
        <tbody>
          {images.length === 0 ? (
            <tr><td colSpan="5">No images added yet.</td></tr>
          ) : images.map((img, i) => (
            <tr key={img.id}>
              <td>{i + 1}</td>
              <td><img src={img.url} alt={img.name} height="60" style={{ borderRadius: "6px", objectFit: "cover" }} /></td>
              <td>{img.name}</td>
              <td>{img.place}</td>
              <td><button className="btn btn-danger btn-sm" onClick={() => handleDelete(img.id)}>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SuccessStoryManager;
